import { ITabData } from '../../Component/DataGrid/Interface';
import { UserDetailsPermissions, TransactionLogsPermissions } from "../../Component/Permissions/PermissionsInterface.";

export interface IUserDetails {
    user_id: string;
    name: string;
    firstName: string;
    lastName: string;
    dob: string;
    email: string;
    mobile_number: string;
    user_status_id: number;
    personaId: string;
    isVerificationRequired: number;
    address_line1: string;
    address_line2: string;
    city: string;
    state: string;
    zip: number;
    admin_comment: string;
    transactionCount: number;
    totalAmount: number;
    lastTransactionDate: string;
}

export interface ISupportStaffs {
    first_name: string;
    last_name: string;
    email: string;
    user_status_id: number; // User status is a number
    role_id: string;
    user_id: string;
    address_line1: string;
    address_line2?: string; // Optional if it may be empty
    city: string;
    state: string;
    zip: string;
    roleName: string;
}
export interface IAdmins {
    first_name: string;
    last_name: string;
    email: string;
    user_status_id: number;
    user_id: string;
    address_line1: string;
    address_line2?: string;
    city: string;
    state: string;
    zip: string;
    role_id?: string;
    roleName?: string;
    mobile_number?: string;
}

export type IDataRowUsers = IUserDetails | ISupportStaffs | IAdmins

export interface UserDetailsState {
    accessToken: string;
    userData: IUserDetails[],
    csvData?: IDataRowUsers[],
    allSupportStaffs: ISupportStaffs[]
    allAdmins: IAdmins[]
    currentRowsPerPage: number,
    currentPage: number,
    totalRows: number,
    searchText: string,
    userId: string,
    isStatusHistory: boolean
    selectedUserData: IUserDetails,
    isLoginHistory: boolean,
    isCommonDialogOpen: boolean,
    selectedTab: number,
    isOpenAddUserDialog: boolean,
    isOpenUpdatePermission: boolean
    selectedSupportStaff: ISupportStaffs,
    userDetails: UserDetailsPermissions,
    transactionLogs: TransactionLogsPermissions,
    selectedAdminData: IAdmins;
    isOpenEditUserDetailsDialog: boolean;
    email_id: string;
    paginationReset: boolean;
    isOpenAdminComments: boolean;
    blockStatus: number;
    statusName: string;
    tabData: ITabData[];
}

export interface TableData {
    rowHeaders: string[];
    standard: string[];
    premium: string[];
    business: string[];
};

export interface ExistingLimits {
    transactionLimitId: string;
    userId: string;
    hourlyLimit: string;
    dailyLimit: string;
    weeklyLimit: string;
    monthlyLimit: string;
    yearlyLimit: string;
    userCategory: string;
    startDate: string;
    endDate: string;
    isSingleTransaction: boolean;
    createdUTC: string;
    modifiedUTC: string;
}

export enum UserCategories {
    StandardUser = 'Standard',
    PremiumUser = 'Premium',
    BusinessUser = 'Business'
}

export interface UserSettingsState {
    selectedDateRange: { startDate: Date; endDate: Date; };
    selectedTempDateRange: { startDate: Date; endDate: Date; };
    popOverTargetElementForDateRange: HTMLElement | null,
    popOverTargetElementForTempDateRange: HTMLElement | null,
    noOfTransactionsPerMonth: string;
    noOfTransactionsPerDay: string;
    hourlyLimit: string;
    dailyLimit: string;
    weeklyLimit: string;
    monthlyLimit: string;
    yearlyLimit: string;
    temporaryLimit: string;
    maxLimitPerTransaction: string,
    inputType: string;
    userType: UserCategories;
    isSingleTransaction: boolean;
    isLimitConfirm: boolean;
    existingLimits: ExistingLimits[];
    openViewDetails: boolean;
    standardHourlyLimit: string;
    standardDailyLimit: string;
    standardWeeklyLimit: string;
    standardMonthlyLimit: string;
    standardYearlyLimit: string;
    premiumHourlyLimit: string;
    premiumDailyLimit: string;
    premiumWeeklyLimit: string;
    premiumMonthlyLimit: string;
    premiumYearlyLimit: string;
    businessHourlyLimit: string;
    businessDailyLimit: string;
    businessWeeklyLimit: string;
    businessMonthlyLimit: string;
    businessYearlyLimit: string;
    initialUserType: string;
    hourlyLimitError: string;
    dailyLimitError: string;
    weeklyLimitError: string;
    monthlyLimitError: string;
    isDeleteHistory: boolean;
    selectedLimit: string;
    annualLimitError: string;
    maxLimitPerTransactionError: string;
    checkedFields: {
        hourlyLimit: boolean,
        dailyLimit: boolean,
        weeklyLimit: boolean,
        monthlyLimit: boolean,
        yearlyLimit: boolean,
        maxLimitPerTransaction: boolean
    },
    currencySymbol: string;
    accessToken: string;
    isUserSettingSaveBtnVisible: boolean;
    optionalSingleTransactionLimit: string;
    initialOptionalSingleTransactionLimit: string;
}

export interface UserSettingsProps {
    userId: string;
    accessToken: string
    onValidationChange?: (hasErrors: boolean) => void;
    onClose?: (state: boolean, action: string) => void;
}

export interface UserDetailsProps {

}

export enum TabsUserDetails {
    MobileUsers,
    SupportStaffs,
    Admins
}
//string enums cannot be reverse mapped, so there is no option, but to create duplicate enum to hold names
export enum TabsUserDetailsNames {
    MobileUsers = "Mobile Users",
    SupportStaffs = "Support Staffs",
    Admins = "Admins"
}
export enum TabsUserDetailsWidths {
    MobileUsers = 140,
    SupportStaffs = 155,
    Admins = 130
}